import { Link } from 'gatsby';
import ProductsArticles from 'components/Products/Others/IntroOtherProducts';
import NavButtons from 'components/Products/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  ProductsArticles,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};